import i18n from 'i18next';

export default ({ type }) => {
  const TYPE_CONTENT_MAPPING = {
    live: {
      deleteTitle: i18n.t('delete-video'),
      deleteBody: i18n.t('delete-video-help'),
      deleteBaseApiUrl: '/api/admin/live_videos',
    },
    topic: {
      deleteTitle: i18n.t('delete-video-topic'),
      deleteBody: i18n.t('delete-video-topic-help'),
      deleteBaseApiUrl: '/api/admin/videos/topics',
    },
    video: {
      deleteTitle: i18n.t('delete-video'),
      deleteBody: i18n.t('delete-video-help'),
      deleteBaseApiUrl: '/api/admin/videos',
    },
    videoLocale: {
      deleteTitle: i18n.t('delete-video-locale'),
      deleteBody: i18n.t('delete-video-locale-help'),
      deleteBaseApiUrl: '/api/admin/videos',
    },
  };

  return {
    ...TYPE_CONTENT_MAPPING[type],
  };
};
